import styles from "./styles.module.css";
import { useState, useEffect, useContext } from "react";
import { BlocksValue } from "../../../../contexts/blocks";
import Condition from "./condition";
import { makeid } from "../../../../utils/pageactions";
import useParentSources from "../../../../utils/useparentsources";

export default function Conditional({ block, path, onChange }) {
  const [schema, setSchema] = useState(null);
  const blocks = useContext(BlocksValue);
  const [conditions, setConditions] = useState([]);
  const [children, setChildren] = useState([]);
  const sources = useParentSources(path);

  useEffect(() => {
    const _schema = blocks.find((x) => x.name === block.component);
    setSchema(_schema);
  }, [block.component]);

  useEffect(() => {
    if (block.conditions) {
      setConditions(block.conditions);
    } else {
      setConditions([]);
    }
  }, [block.conditions]);

  useEffect(() => {
    if (block.children.length > 0) {
      const children = [];
      const dive = (block) => {
        block.children.forEach((c) => {
          children.push(c);
          if (c.children.length > 0) {
            dive(c);
          }
        });
      };
      dive(block);
      setChildren(children);
    } else {
      setChildren([]);
    }
  }, [block]);

  const addCondition = () => {
    const _conditions = [...conditions];
    _conditions.push({
      state: "",
      props: {},
      id: makeid(16),
    });
    setConditions(_conditions);
    handleSave(_conditions);
  };

  const updateCondition = (v, i) => {
    const _conditions = [...conditions];
    _conditions[i] = v;
    setConditions(_conditions);
    handleSave(_conditions);
  };

  const deleteCondition = (i) => {
    const _conditions = [...conditions];
    _conditions.splice(i, 1);
    setConditions(_conditions);
    handleSave(_conditions);
  };

  const handleSave = (c) => {
    const _block = { ...block };
    _block.conditions = c;
    onChange(_block);
  };
  return (
    <div className={styles.conditional}>
      <div className={styles.title}>Conditional Props</div>
      <div className={styles.container}>
        {conditions.map((c, i) => {
          return (
            <Condition
              key={c.id}
              condition={c}
              index={i}
              sources={sources}
              block={block}
              schema={schema}
              children={children}
              onChange={(v) => updateCondition(v, i)}
              onDelete={() => deleteCondition(i)}
            />
          );
        })}
      </div>
      <button onClick={addCondition} className={styles.add}>
        Add Condition
      </button>
    </div>
  );
}
